import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
  selector: 'loyaltic-win',
  templateUrl: './win.component.html',
  styleUrls: ['./win.component.scss']
})
export class WinComponent implements OnInit {

  winDetails: any;
  rewardId : string = '';

  constructor( private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private dataService:DataServiceService,
    public translate: TranslateService,
    private coreService: CoreService) {
      
    this.winDetails = this.dataService.getWinDetails();
    console.log("=======windetails", this.winDetails)
       

  }


     ngOnInit() {



     }



  ngAfterViewInit() {

  }

}
